import axios from "axios";

const oldVersionApi = JSON.parse(process.env.REACT_APP_OLD_VERSION_API || false) || false;

const setUpServicesHandler = ({
  postRequest,
  getRequest,
  putRequest,
  deleteRequest,
}) => {
  return {
    serviceSigninUser: ({ body }) => postRequest(`loginUser`, body),
    serviceChangePassword: ({ body }) => postRequest('editPass', body),

    /*
      Dashboard services
    */
    serviceGetDashboard: ({ query }) => {
      return getRequest(`getDash?fecha_desde=${query.dateFrom}&fecha_hasta=${query.dateTo}&project_id=${query.projectId}&baseUrl=${query.baseUrl}`)
    },

    /*
      Workflow services
    */
    servicePostWorkflow: ({ body }) => postRequest('insertWorkFlowTemplates', body),

    /*
      Template services
    */
    servicePostTemplate: ({ body }) => {
      return postRequest('insertWorkTemplates', body)
    },
    servicePutTemplate: ({ body }) => postRequest('editWorkTemplates', body),
    serviceDeleteTemplate: ({ body }) => postRequest('deleteWorkTemplates', body),
    serviceGetTemplate: ({ query }) => {
      let baseQuery = `worktemplate_id=${query.templateId}`;
      return getRequest(`getWorkTemplates?${baseQuery}`);
    },
    serviceGetTemplates: ({ query }) => {
      let baseQuery = `tipo=${query.type}&proyect_id=${query.projectId}`;
      if (query?.search) baseQuery += `&q=${query.search}`;
      return getRequest(`getWorkTemplates?${baseQuery}`);
    },
    serviceGetTemplateInteraction: ({ query }) => getRequest(`getWorkTemplateUserInteraction?worktemplate_id=${query.templateId}`),
    serviceGetTemplateByProject: ({ query }) => getRequest(`getWorkTemplatesParam?project_id=${query.projectId}`),
    serviceGetAllTemplates: () => getRequest('getWorkTemplatesParam'),

    /*
      Inventories Services
    */
    //TODO: DELETE THIS PLEASE >:l
    serviceGetInventories: oldVersionApi
    ? ({ query }) => getRequest(`getInventory?baseUrl=${query.baseUrl}`)
    : ({ query }) => {
      let baseQuery = `getInventories`;
      if (query?.search) baseQuery += `?q=${query.search}`;
      return getRequest(baseQuery);
    },
    serviceGetInventory: ({ query }) => getRequest(`getInventoryNew?name=${query.name}`),
    servicePostInventory: ({ body }) => putRequest('insertInventory', body),
    serviceDeleteInventory: ({ body }) => deleteRequest(`deleteInventory?name=${body.name}`),
    servicePutInventory: ({ body }) => postRequest('updateInventory', body),

    /*
      Data model services
    */
    serviceGetDataModels: ({ query }) => getRequest(`getDataModel?baseUrl=${query.baseUrl}`),
    serviceGetDataModel: ({ query }) => getRequest(`getDataModelFile?baseUrl=${query.baseUrl}&f=${query.file}`),
    servicePostDataModel: ({ body }) => postRequest(`setDataModelFile`, body),
    servicePutDataModel: ({ body }) => postRequest(`setDataModelFile`, body),
    serviceDeleteDataModel: ({ body }) => deleteRequest(`deleteDataModelFile?baseUrl=${body.baseUrl}&f=${body.f}`),

    /*
      Documentation Services
    */
    serviceGetDocuments: ({ query }) => getRequest(`getDocuments?baseUrl=${query.baseUrl}`),
    serviceGetDocument: ({ query }) => getRequest(`getDocumentsFile?baseUrl=${query.baseUrl}&f=${query.document}`),

    /*
      Credentials Services
    */
    //TODO: DELETE THIS PLEASE >:l
    serviceGetCredentials: oldVersionApi
    ? ({ query }) => getRequest(`getCredentials?project_id=${query.projectId}`)
    : ({ query }) => {
      let baseQuery = `getCredentialsNew`;
      if (query?.search) baseQuery += `?q=${query.search}`;
      return getRequest(baseQuery);
    },

    serviceGetCredential: oldVersionApi
    ? ({ query }) => getRequest(`getCredentials?credentials_id=${query.credentialId}`)
    : ({ query }) => {
      let baseQuery = `getCredential?credential_id=${query.credential_id}`;
      return getRequest(baseQuery);
    },

    servicePostCredential: oldVersionApi
    ? ({ body }) => postRequest('insertCredentials', body)
    : ({ body }) => putRequest('insertCredential', body),

    servicePutCredential: oldVersionApi
    ? ({ body }) => postRequest('editCredentials', body)
    : ({ body }) => postRequest('updateCredential', body),

    serviceDeleteCredential: ({ body }) => deleteRequest(`deleteCredential?credential_id=${body.credential_id}`),


    /*
      Proyects Services
    */
    serviceGetProjects: ({ query }) => {
      let baseQuery = `getProjects`;
      if (query?.search) baseQuery += `?q=${query.search}`;
      return getRequest(baseQuery);
    },
    serviceGetProject: ({ query }) => getRequest(`getProjects?project_id=${query.projectId}`),
    servicePostProject: ({ body }) => postRequest('insertProject', body),
    servicePutProject: ({ body }) => postRequest('editProject', body),
    serviceDeleteProject: ({ body }) => postRequest('deleteProject', body),
    serviceSyncProject: ({ body }) => postRequest('syncProject', body),

    /*
      companies Services
    */
    serviceGetCompanies: ({ query }) => {
      let baseQuery = `getCompanies`;
      if (query?.search) baseQuery += `?q=${query.search}`;
      return getRequest(baseQuery);
    },
    serviceGetCompany: () => getRequest(`getCompanies`),
    servicePostCompany: ({ body }) => postRequest('insertCompany', body),
    servicePutCompany: ({ body }) => postRequest('editCompany', body),
    serviceDeleteCompany: ({ body }) => postRequest('deleteCompany', body),

    /*
      Users Services
    */
    serviceGetUsers: ({ query }) => {
      let baseQuery = 'getUsers';
      if (query?.search) baseQuery += `?q=${query.search}`;
      return getRequest(`${baseQuery}`);

    },
    serviceGetUser:     ({ query }) => getRequest(`getUsers?username=${query.username}`),
    servicePostUser:    ({ body })  => postRequest('insertUser', body),
    servicePutUser:     ({ body })  => postRequest('editUser', body),
    serviceDeleteUser:  ({ body })  => postRequest('deleteUser', body),

    /*
      Configuration Services
    */
    serviceGetConfiguration: () => getRequest(`getConfiguration`),
    servicePutConfiguration: ({ body }) => postRequest('saveConfiguration', body),

    /*
      Macro
    */
    serviceGetExecuteFileData: ({ query }) => getRequest(`getExecuteFileData?filename=${query.filename}`),
    serviceGetConfigFiles: () => getRequest(`getConfigFiles`),
    servicePostMacro: (body) =>  postRequest('executeMacro', body),


    /*
      Job Services
    */
    serviceGetJobs: ({ query }) => {
      console.log(query)
      let baseQuery = 'getJob';
      if (query?.projectId) baseQuery += `?project_id=${query.projectId}`;
      if (query?.macro) baseQuery += `?macro=true`;
      if (query?.search) baseQuery += `&q=${query.search}`;
      return getRequest(`${baseQuery}`);
      //getRequest(`getJob?project_id=${query.projectId}`)
    },
    serviceGetJobRun: ({ query }) => getRequest(`getJob?job_id=${query.jobId}`),
    serviceGetJobRunPage: ({ query }) => getRequest(`getJob?job_id=${query.jobId}&page=${query.page}`),
    servicePostJobRun: ({ body }) => postRequest('runNewJob', body),
    servicePostJobAbort: ({ body }) => postRequest('abortarJob', body),
    servicePostJobAbortAll: ({ body }) => postRequest('limpiarColaDeEjecucion', body),
    serviceGetJobStatus: ({ query }) => getRequest(`getJobStatus?job_ids=${query.jobId}`),
    serviceGetJobTail: ({ query }) => getRequest(`getCurrentTail?job_id=${query.jobId}`),
    serviceGetJobWorkflowDef: ({ query }) => getRequest(`getJobStatusWF?job_ids=${query.jobs}`),

    /*
      Roles
    */
    serviceGetRoles: ({query}) => {
      let baseQuery = 'getRoles';
      if (query?.search) baseQuery += `?q=${query.search}`;
      return getRequest(`${baseQuery}`);
    },
    serviceGetRole: () => getRequest(`getRoles`),
    servicePostRole: ({ body }) => postRequest('insertRole', body),
    servicePutRole: ({ body }) => postRequest('editRole', body),
    serviceDeleteRole: ({ body }) => postRequest('deleteRole', body),

    /*
      others Services
    */
    serviceGetAllParameters: ({ query }) => getRequest(`allParameters?user=${query.user}`),
    serviceGetPlaybooks: ({ query }) => getRequest(`getPlaybooks?baseUrl=${query.baseUrl}`),
    serviceGetProjectsUsers: ({ query }) => getRequest(`getUsersProject?project_id=${query.projectId}`),

    /*
      API Token Admin Services
    */
    serviceGetApiClients: () => getRequest('getApiClients'),
    servicePostApiClient: ({ body }) => postRequest('insertApiClient', body),
    serviceToggleApiClient: ({ body }) => postRequest('toggleApiClient', body),
    serviceDeleteApiClient: ({ query }) => deleteRequest(`deleteApiClient?client_id=${query.client_id}`),
    serviceGetApiTokens: ({ query }) => {
      let base = 'getApiTokens';
      if (query?.client_id) base += `?client_id=${query.client_id}`;
      return getRequest(base);
    },
    serviceGetApiTemplates: () => getRequest('getApiTemplates'),
    servicePostApiToken: ({ body }) => postRequest('insertApiToken', body),
    serviceRevokeApiToken: ({ body }) => postRequest('revokeApiToken', body),
    serviceDeleteApiToken: ({ body }) => postRequest('deleteApiToken', body),
    serviceGetApiAuditLog: ({ query }) => {
      const params = new URLSearchParams();
      if (query?.client_id) params.append('client_id', query.client_id);
      if (query?.token_id) params.append('token_id', query.token_id);
      if (query?.limit) params.append('limit', query.limit);
      if (query?.offset) params.append('offset', query.offset);
      return getRequest(`getApiAuditLog?${params.toString()}`);
    },

  };
};

export default setUpServicesHandler;
